/**
 * Bounds on the natural-language prompt the workflow builder accepts.
 *
 * The REST routes enforce this through `validateBody`, but the AI and MCP tool
 * wrappers call the handlers directly and never see route middleware — so the
 * tool manifests and the handlers enforce the same bounds. Keeping one constant
 * means the three entry points cannot drift apart.
 */
export const BUILDER_PROMPT_MAX_LENGTH = 4000;
